module.exports = __webpack_public_path__ + "static/media/CustomIconScience.391d7a20.svg";